/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                         Description
----------   -----------          --------------- ----------------      ------------------------
01 07 2018    1                     Professional service Initial version     
04-12-2019    1.2                   Pappuraj                             Date picker added 
05-12-2019    1.3                   Pappuraj                             Date picker funciton modified 
*/

import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { RestapiService } from 'src/app/service/api/restapi.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-existingCustomer',
  templateUrl: './existingCustomer.component.html',
  styleUrls: ['./existingCustomer.component.scss'],
})
export class ExistingCustomerComponent implements OnInit {
  langcontext: any;
  context: any;
  headingTitle: any;
  public registerForm: FormGroup;
  formsubmitted: any = false;
  firstnumber: any;
  secondnumber: any;
  emailId: any;
  mobileNumber: any;
  dob: any;
  typedValue: any;
  validcaptcha: boolean = false;
  newPwd = "";
  currentpath;
  maxDate: any;
  constructor(private router: Router, public platform: Platform, public _sanitizer: DomSanitizer, public navctrl: NavController, public formBuilder: FormBuilder, public cmndef: CommonDefinitionService, public cmndecl: CommonDeclarationService, public api: RestapiService) {
    this.currentpath = this.router.url;
    console.log(this.currentpath);
    this.registerForm = formBuilder.group({
      emailId: ['', Validators.compose([
        Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')
      ])],
      mobileNumber: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(15)])],
      dob: ['', Validators.required],
      typedValue: ['', Validators.required],
    });

    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['ExistingCustomer'];
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].ExistingCustomer;
    }
    this.platform.ready().then(() => {
      this.api.postapi("getContextMenu", {}).then(data => {
        console.log(data);
        this.cmndecl.storeProcess(data,"contexualmenu")
      }, err => {
        console.log("err");
      });
    });

    this.headingTitle = this.langcontext.heading.text;
    this.firstnumber = Math.floor(Math.random() * 10);
    this.secondnumber = Math.floor(Math.random() * 10);
  }


  ngOnInit() {
    this.maxDate = new Date().toISOString();
  }

  showDatepicker() {
    if (this.dob == undefined || this.dob == null || this.dob == "") {
      let fulldate = new Date('01/01/2001');
      let mdte = new Date();
      this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
        this.dob = data;
      }, err => {
        console.log(err);
      });
    }
    else {
      let split = this.dob.split("/");
      let sdate = split[1] + "/" + split[0] + "/" + split[2]
      var d = new Date(sdate);
      let mdte = new Date();
      this.cmndef.showdatePicker(d, "", mdte).then(data => {
        this.dob = data;
      }, err => {
        console.log(err);
      });
    }
  }


  async registration() {
    let mobile: any;
    if (this.mobileNumber == undefined || this.mobileNumber == NaN || this.mobileNumber == "") {
      this.mobileNumber = "";
      mobile = this.mobileNumber
    }
    else {
      mobile = parseInt(this.mobileNumber)
    }
    console.log(this.mobileNumber)
    let dobdate: any;

    if (this.registerForm.get("dob").valid && this.registerForm.get("typedValue").valid && (this.registerForm.get("emailId").valid || this.registerForm.get("mobileNumber").valid)) {
      console.log(this.emailId);
      if (this.cmndecl.cordovaSupport)
        dobdate = this.dob;
      else
        dobdate = moment(this.dob).format("DD/MM/YYYY");

      let data = {
        "requestType": "PREREGISTER",
        "mobileNo": mobile,
        "userType": "2",
        "userType2": {
          "emailId": this.emailId || "",
          "dob": dobdate,
          "password": this.newPwd
        }
      }
      let varpath = this.currentpath;
      let userDetails = {};
      let userData = data;
      /*api call for registration based on registered and non registered customer*/

      await this.api.postapi("userRegistration", data).then(response => {
        console.log(response)
        // if (response.responseCode == "001") {
        var dataObj = {};
        dataObj = data;
        dataObj['userType2'].policyNo = response['policyNo'];
        dataObj['userType2'].clientId = response['clientId']
        dataObj['requestType'] = "REGISTER";
        this.cmndef.preRegisterData = dataObj;
        console.log(dataObj)

        userDetails = {
          mobileNo: (userData.mobileNo).toString() ? userData.mobileNo.toString() : "",
          dob: userData.userType2.dob ? userData.userType2.dob : "",
          state: response['state'],
          emailId: userData.userType2.emailId ? userData.userType2.emailId : "",
          userId: userData.mobileNo.toString() ? userData.mobileNo.toString() : (userData.userType2.emailId ? userData.userType2.emailId : "")
        }
        console.log(userDetails)
        /*service for setting mobile number and dob fields for other api calls further*/
        this.cmndecl.storeProcess(userDetails,"profile")
        this.cmndef.setUserInfo = userDetails;
        console.log(this.cmndef.setUserInfo)
        if (varpath == '/prospregister') {
          sessionStorage.CurrentPage = "/verifyOtpVa";
          this.navctrl.navigateRoot("/verifyOtpVa");
        }
        else {
          sessionStorage.CurrentPage = "/verifyOtpReg";
          this.navctrl.navigateRoot("/verifyOtpReg");
        }
      }, function (err) { });
    }
    else {
      console.log("notvalid")
    }

  }

  register(data) {


  }


  showinfo(msg) {
    this.cmndef.presentAlert("", msg, "info");
  }

  validatefun(event: any, flg: any) {
    if (flg == 'emailId') {
      this.emailId = this.emailId.replace(/[^A-Za-z0-9-@!#$%&*+./?^_`{}|]/g, "");
    }
    else if (flg == 'mobileNumber') {
      this.mobileNumber = this.mobileNumber.replace(/[^0-9]/g, '');
    }
  }


  typeingvalue() {
    console.log(this.typedValue)
    if ((this.firstnumber + this.secondnumber) == this.typedValue) {
      this.validcaptcha = true
    }
    else {
      this.validcaptcha = false;
    }
  }
}
